import { ChangeDetectionStrategy, Component, HostListener, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'confirm-dialog',
  templateUrl: './confirm.dialog.html',
  styleUrls: ['./confirm.dialog.css']
})

export class ConfirmDialog {

  constructor(@Inject(MAT_DIALOG_DATA)
  public data: any,
  private dialogRef: MatDialogRef<ConfirmDialog>)
  {
  }

  public yes() {
    this.dialogRef.close("yes");
  }

  public no() {
    this.dialogRef.close();
  }


  @HostListener("keydown.esc")
  public onEsc() {
    this.no();
  }

}
